import React from "react";
import { Container } from "./style";
import GoogleMap from "../../components/Maps/GoogleMap";

export default () => (
    <Container>
        <GoogleMap />
    </Container>
);
